import { StyledStars02 } from '@risksmart-app/components/src/styled-stars-02/StyledStars02';
import clsx from 'clsx';
import type { FC } from 'react';

import { useSidePanelStore } from '@/components/side-panel/useSidePanelStore';

import styles from './ChatButton.module.scss';

export const ChatButton: FC = () => {
  const {
    isOpen: isSidePanelOpen,
    close: closeSidePanel,
    openFor: openSidePanelFor,
    mode: sidePanelMode,
  } = useSidePanelStore();

  const handleToggleChat = () => {
    if (isSidePanelOpen && sidePanelMode === 'ai-chat') {
      closeSidePanel();
    } else {
      openSidePanelFor('ai-chat');
    }
  };

  return (
    <button
      className={clsx(
        styles.styledButton,
        isSidePanelOpen && styles.styledButtonOpen
      )}
      onClick={handleToggleChat}
      type={'button'}
      title={'Toggle chat'}
    >
      <StyledStars02 asIcon size={24} />
    </button>
  );
};
